import { useState, useEffect } from 'react';
import { Breadcrumb } from 'components/Breadcrumb';
import { MdOutlineFileDownload } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { useDispatch, useSelector } from 'react-redux';
import { getStatusActionsAction } from 'store/modules/claims/actions';

import { ApplicationState } from 'store/store.inteface';

import { Button } from '@grupoboticario/flora-react';
import { downloadFile } from 'utils/downloadFile';
import { Container, Content, Title, Card } from './styles';

export function NegativeLetter() {
  const { id } = useParams();
  const history = useHistoryWithHost();
  const [loadingData, setLoadingData] = useState(false);
  const dispatch = useDispatch();
  const { statusActions } = useSelector(
    (state: ApplicationState) => state.claims,
  );
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  useEffect(() => {
    if (stores.length > 0) {
      dispatch(getStatusActionsAction(id));
    }
  }, [dispatch, id, stores]);

  useEffect(() => {
    setLoadingData(false);
    if (!statusActions.documentAction) {
      setLoadingData(true);
    }
  }, [statusActions]);
  return (
    <Container>
      <Breadcrumb color="light" claimNumber={statusActions.number} />
      <Content>
        <Title>
          <span>Carta Negativa</span>
        </Title>
        <Card>
          <div>
            <MdOutlineFileDownload className="download" />
          </div>
          <div>
            Informamos que o seu sinistro foi negado e será encerrado na
            seguradora. Para maiores esclarecimentos por favor consulte a carta
            em anexo.
          </div>
          <div>
            <Button
              isLoading={loadingData}
              size="small"
              disabled={!statusActions.fileAction?.url}
              onClick={() =>
                downloadFile(
                  statusActions.fileAction?.url,
                  `Carta Negativa - Sinistro #${statusActions.number}`,
                )
              }
            >
              Baixar
            </Button>
          </div>
        </Card>
        <Button size="small" onClick={() => history.goBack()}>
          Sair
        </Button>
      </Content>
    </Container>
  );
}
